module.exports = __webpack_public_path__ + "img/gate_running.6ac572d.svg";